import React, { Component } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Table, Tag, Space } from 'antd';
import { Select } from 'antd';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { DatePicker, TimePicker } from 'antd';
import { Modal } from 'antd';
const { Option } = Select;


class WorkOrder extends Component {
    constructor(props) {
        super(props);
        const config = JSON.parse(Config);
        this.state = {
            title: 'Work Order',
            apiInterface: config['api1'],
            TableColumns: [
                {
                    title: 'Action',
                    dataIndex: 'action',
                    key: 'action',
                    render: (text, record) => (
                        <Space size="middle">
                            <div className="table-icons">
                                <i className="fa fa-pencil blue" aria-hidden="true" onClick={this._doNavToAddStore}></i>
                            </div>
                        </Space>
                    ),
                },
                {
                    title: "Store Name",
                    dataIndex: "StoreName",
                    key: "StoreName"
                },
                {
                    title: "Request Id",
                    dataIndex: "RequestId",
                    key: "RequestId"
                },
                {
                    title: "Date & Time",
                    dataIndex: "DateTime",
                    key: "DateTime"
                },
                {
                    title: "Status",
                    dataIndex: "Status",
                    key: "Status"
                },
            ],
            TableData: [
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Pending for Confirmation By Vendor'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'AcceptedAccepted by Vendor'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Rejected By Vendor'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Resheduled By Store'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Resheduled By Vendor'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Technician Completed'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Technician In Completed'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Quotation pending'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Work Accepted by Store'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Work Rejected by Store'
                },
                {
                    StoreName: 'Store 1',
                    RequestId: '123',
                    DateTime: '16-09-2021 3:00PM',
                    Status: 'Close'
                },

            ],
            States: [
                {
                    Label: "Karnataka",
                    Value: 1
                },
                {
                    Label: "Tamil Nadu",
                    Value: 2
                },
                {
                    Label: "Telangana",
                    Value: 3
                },
                {
                    Label: "Andhra Pradesh",
                    Value: 4
                },
                {
                    Label: "Maharashtra",
                    Value: 5
                },
                {
                    Label: "Delhi",
                    Value: 6
                },
                {
                    Label: "Kerala",
                    Value: 7
                },
            ],
            Status: [
                {
                    Active: "Yes",
                    Value: 1
                },
                {
                    Active: "No",
                    Value: 2
                },
            ],
            IsPMPScheduleOpen: false,
            MainCategories: [
                {
                    Label: "Electrical",
                    Value: "MC001"
                },
                {
                    Label: "Electronic Appliance",
                    Value: "MC002"
                },
                {
                    Label: "Stabiliser",
                    Value: "MC003"
                },
                {
                    Label: "DG",
                    Value: "MC004"
                },
                {
                    Label: "Fire Fight System",
                    Value: "MC005"
                },
                {
                    Label: "Fire Alarm System",
                    Value: "MC006"
                },
                {
                    Label: "UPS System",
                    Value: "MC007"
                },
                {
                    Label: "Burglar Alarm System",
                    Value: "MC008"
                },
                {
                    Label: "PA System",
                    Value: "MC009"
                },
                {
                    Label: "Chiller AC System",
                    Value: "MC010"
                },
                {
                    Label: "VRV AC System",
                    Value: "MC011"
                },
                {
                    Label: "HVLS Fans",
                    Value: "MC012"
                },
                {
                    Label: "STP",
                    Value: "MC013"
                },
                {
                    Label: "Lift",
                    Value: "MC014"
                },
                {
                    Label: "Escalator",
                    Value: "MC015"
                },
                {
                    Label: "CCTV",
                    Value: "MC016"
                },
                {
                    Label: "Solar",
                    Value: "MC017"
                },
                {
                    Label: "Door & Shutter",
                    Value: "MC018"
                },
                {
                    Label: "Roof",
                    Value: "MC019"
                },
                {
                    Label: "Domestic Water",
                    Value: "MC020"
                },
                {
                    Label: "Dock Leveler",
                    Value: "MC021"
                },
                {
                    Label: "Convyer Belt",
                    Value: "MC022"
                },
                {
                    Label: "MHE",
                    Value: "MC023"
                },
            ],
            SubCategories: [
                {
                    Label: "Transformer",
                    Value: "SC001"
                },
                {
                    Label: "RMU",
                    Value: "SC002"
                },
                {
                    Label: "UPS1",
                    Value: "SC003"
                },
                {
                    Label: "UPS2",
                    Value: "SC004"
                },
                {
                    Label: "Power Generator",
                    Value: "SC005"
                },
                {
                    Label: "Stabilizer",
                    Value: "SC006"
                },
                {
                    Label: "Fire Alarm System",
                    Value: "SC007"
                },
                {
                    Label: "Burglar Alarm System",
                    Value: "SC08"
                },
                {
                    Label: "PA System",
                    Value: "SC009"
                },
                {
                    Label: "Fire Extinguishers",
                    Value: "SC010"
                },
                {
                    Label: "Fire Hose reels",
                    Value: "SC011"
                },
                {
                    Label: "Fire Hydrant",
                    Value: "SC012"
                },
                {
                    Label: "Light fittings",
                    Value: "SC013"
                }
            ],
            IsEdit: false,
            loading: false,
            message: '',
            modalOpen: false,
            QuotationInComplete: false,
            CreateQuotation: false,
            PendingForConfirmationByVendor: false,
            Accept: false,
            RejectedModal: false,
            RescheduleModal: false,
            PendingConfirm: false,
            Reject: false,
            Reschedule: false,
            TechnisianCompleted: false,
            TechnisianCompletedReject: false,
            StoresList: [
                {
                    Label: "Connect Store - ITPB",
                    Value: 1
                },
                {
                    Label: "Connect Store- Indiranagar",
                    Value: 2
                },
                {
                    Label: "Sarjapur",
                    Value: 3
                },
                {
                    Label: "Anubhava (New Airport Road)",
                    Value: 4
                },
                {
                    Label: "EVA Mall - Brigade",
                    Value: 5
                },
                {
                    Label: "R-city(Mumbai)",
                    Value: 6
                },
                {
                    Label: "Amanora Mall",
                    Value: 7
                },
                {
                    Label: "OMR Padur(Chennai)",
                    Value: 8
                },
                {
                    Label: "Teynampet / Ramee Mall / Anna Salai",
                    Value: 9
                },
                {
                    Label: "Kukatpally (Manjeera Mall)",
                    Value: 10
                },
                {
                    Label: "Vishakapatnam (Murli Nagar)",
                    Value: 11
                },
            ],
        }
    }

    componentDidMount() {
        this._doGetWorkOrderList();
      };
    
      _doGetWorkOrderList() {
        this.setState({
          loading: true,
          modalOpen: false,
          message: "",
        });
        ApiGateWay.GetData(
          this.state.apiInterface +
          '/AssetInfo/loadallassetsinfo')
          .then((response) => {
            // console.log(response)
            // if (response) {
            //   let Asset = [];
            //   response[14].Table15.forEach((element, index) => {
            //     Asset.push({
            //       key: index + 1,
            //       Lot: element.lot,
            //       SubCategory: element.sub_category_name,
            //       AssetName: element.asset_name,
            //       Vendor: "",
            //       Status: ""
            //     })
            //   });
            //   this.setState(
            //     {
            //       TableData: Asset,
            //     }
            //   )
            // };
            this.setState({
              loading: false,
              modalOpen: false,
              message: "",
            });
          })
      };
    
    _doNavToAddStore = () => {
        // this.props.navigate("/AddStore");
    };
    _doNavToViewStore = () => {
        // this.props.navigate("/StoreView");
    }

    _doGetRowData = (item) => {
        console.log(item);
        this.setState({
            assetDetails: {
                Lot: item.Lot,
                SubCategory: item.SubCategory,
                AssetName: item.AssetName
            }
        },
        )
        if (item.Status === 'Technician In Completed') {
            this.setState({
                QuotationInComplete: true
            })
        }
        else if (item.Status === 'Pending for Confirmation By Vendor') {
            this.setState({
                PendingForConfirmationByVendor: true,
                PendingConfirm: true
            })
        }
        else if (item.Status === 'Technician Completed') {
            this.setState({
                TechnisianCompleted: true
            })
        }
    }

    _doTechnisianReject = () => {
        this.setState({
            TechnisianCompletedReject: true
        })
    }
    _doTechnisianRejectBack = () => {
        this.setState({
            TechnisianCompletedReject: false
        })
    }

    _doNavToAddPlanner = () => {
        this.setState({
            IsPMPScheduleOpen: true
        })
        this.setState({
            IsEdit: true,
        })
    }
    _doNavToWOReschedule = () => {
        this.props.navigate("/WOReschedule");
    }
    // _doNavToPMPList = () => {
    //     this.props.navigate("/PMPList");
    // }
    _doNavToEditPlanner = () => {
        this.setState({
            IsPMPScheduleOpen: true
        })
        this.setState({
            IsEdit: true,
        })
    }
    _doNavToCancelPlanner = () => {
        // this.props.navigate("/PMPScheduleCancel");
    }
    _doCloseModal = () => {
        this.setState({
            IsPMPScheduleOpen: false,
            QuotationInComplete: false,
            CreateQuotation: false,
            PendingForConfirmationByVendor: false,
            TechnisianCompleted: false,
        })
    };

    _doCreateQuotation = () => {
        this.setState({
            CreateQuotation: true
        })
    }
    _doQuotationBack = () => {
        this.setState({
            CreateQuotation: false
        })
    }
    _doCloseAcceptModal = () => {
        this.setState({
            AcceptModal: false
        })
    }
    _doAccept = () => {
        this.setState({
            Accept: true,
            PendingConfirm: false,
            Reject: false,
            Reschedule: false
        })
    }
    _doPendingConfirmBack = () => {
        this.setState({
            Accept: false,
            PendingConfirm: true,
            Reject: false,
            Reschedule: false
        })
    }
    _doReSchedule = () => {
        this.setState({
            Accept: false,
            PendingConfirm: false,
            Reject: false,
            Reschedule: true
        })
    }
    _doReject = () => {
        this.setState({
            Accept: false,
            PendingConfirm: false,
            Reject: true,
            Reschedule: false
        })
    }


    render() {

        return (
            <div>
                {this.state.modalOpen ? (
                    <MessageBox
                        message={this.state.message}
                        signout={false}
                        onClose={this.handleClose}
                    />
                ) : null}

                <div className="wrapper">
                    <Header title={this.state.title} />
                    <Menu />

                    <div className='content-wrapper'>
                        {this.state.loading ? (
                            <Spinner />
                        ) : (
                            <div>
                                <div className="m-btn-block">
                                    <div className="m-btn-block__container">
                                        <div className="m-btn-block__icon">
                                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                        </div>
                                        <div className="m-btn-block__btns">
                                            <button type='submit' onClick={this._doNavToAddStore} className='btn btn-secondary deca-btn-yellow'>Create New Work Order</button>
                                        </div>
                                    </div>
                                </div>
                                <section className='content'>
                                    <div className="m-panel mt-10">
                                        <div className="m-panel__body p10">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className='form-group'>
                                                        <label htmlFor='exampleInput'>Select Store</label>
                                                        <Select className="form-control"
                                                            showSearch
                                                            onChange={this._doSelectVender}
                                                            placeholder="-- Please Select --"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                        > {
                                                                this.state.StoresList.map((item =>
                                                                    <Option key={item.Value} value={item.Value}>{item.Label}</Option>
                                                                ))
                                                            }
                                                        </Select>
                                                    </div>
                                                </div>

                                                <div className="col-md-1 btn-no-lbl">
                                                    <button type='submit' className='btn btn-secondary btn-icon deca-btn-yellow'>
                                                        <i className="fa fa-search"></i>
                                                    </button>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="m-reports">
                                                        <div className="m-reports__container">
                                                            <div className="m-reports__item">
                                                                <div className="m-reports__item--box">
                                                                    <h4 className="blue">207</h4>
                                                                </div>
                                                                <h5 className="m-reports__item--title blue">Total</h5>
                                                            </div>
                                                            <div className="m-reports__item">
                                                                <div className="m-reports__item--box">
                                                                    <h4 className="orange">80</h4>
                                                                </div>
                                                                <h5 className="m-reports__item--title orange">Pending</h5>
                                                            </div>
                                                            <div className="m-reports__item">
                                                                <div className="m-reports__item--box">
                                                                    <h4 className="green">127</h4>
                                                                </div>
                                                                <h5 className="m-reports__item--title green">Closed</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="m-panel mt-10">
                                        <div className="m-panel__body p10">
                                            <div className="m-table__main">
                                                <div className="m-table__responsive medium-width">
                                                    <Table onRow={(record, recordIndex) => ({
                                                        onClick: event => { { this._doGetRowData(record, recordIndex) } }
                                                    })}
                                                        filterSearch="true" columns={this.state.TableColumns} dataSource={this.state.TableData} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        )}
                    </div>
                    <Footer />
                    {
                        this.state.IsPMPScheduleOpen === true ?
                            <div className="m-modal">
                                <div className="m-modal__container">
                                    <div className="m-modal__header">
                                        <h5 className="m-modal__title">Work Order Request</h5>
                                        <span className="m-modal__close" onClick={this._doCloseModal}>
                                            <i className="fa fa-close"></i>
                                        </span>
                                    </div>
                                    <div className="m-modal__body">
                                        <div className="row">

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Asset Main category*</label>

                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Asset Sub category*</label>

                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Asset List*</label>
                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="">
                                                    <label htmlFor='exampleInput'>View Image*</label><br />
                                                    <div className="c-pic__img">
                                                        <img src="https://www.rli.uk.com/wp-content/uploads/2019/08/Decathlon.jpg" className="" alt="asset-img" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Date*</label>
                                                    <DatePicker className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Select time*</label>
                                                    <TimePicker use12Hours format="h:mm a" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor='exampleInput'>Assign Technician*</label>
                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-12 text-center">
                                                <div className="m-page__button top-space text-center">

                                                    {
                                                        this.state.IsEdit === true ?
                                                            <button type='button' className='btn muted-button  deca-btn-orange' onClick={this._doNavToCancelPlanner}>Reject</button>
                                                            : ""
                                                    }
                                                    <button type='button' className='btn btn-secondary deca-btn-yellow'>Accept</button>
                                                    {
                                                        this.state.IsEdit === true ?
                                                            <button type='button' onClick={this._doNavToWOReschedule} className='btn btn-secondary deca-btn-yellow'>Re Schedule</button>
                                                            : ""
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            : false
                    }
                    {
                        this.state.IsPMPScheduleOpen === true ?
                            <div className="overlay" onClick={this._doCloseModal}>

                            </div>
                            : false
                    }


                    {
                        this.state.QuotationInComplete === true ?
                            <div className="m-modal">
                                {
                                    this.state.CreateQuotation === false ?
                                        <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Quotation In Complete</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset*</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Submitted Date & Time*</label>
                                                            <input type="text" className="form-control" disabled value="16 Sep 2021 13:38" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Remarks*</label>
                                                            <textarea type="text" rows="3" className="form-control" disabled value="Lorem Ipsum is simply dummy text of the printing and"></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Quotation*</label>
                                                            <input type="text" className="form-control" value="Yes" disabled />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="m-page__button top-space text-center">
                                                            <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={this._doCreateQuotation}>Create Quotation</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Create Quotation</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset Name*</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Brand/Make*</label>
                                                            <input type="text" className="form-control" value="" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Issue Description*</label>
                                                            <textarea type="text" rows="3" className="form-control" value=""></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Capacity*</label>
                                                            <input type="number" className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Cost*</label>
                                                            <input type="number" className="form-control text-right" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>GST %*</label>
                                                            <input type="number" className="form-control text-right" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Total Amount*</label>
                                                            <input type="number" disabled className="form-control text-right" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="m-page__button top-space text-center">
                                                            <button type='button' className='btn muted-button deca-btn-orange' onClick={this._doQuotationBack}>Back</button>
                                                            <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={this._doCreateQuotation}>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                }

                            </div>

                            : false
                    }
                    {
                        this.state.QuotationInComplete === true ?
                            <div className="overlay" onClick={this._doCloseModal}>

                            </div>
                            : false
                    }


                    {
                        this.state.PendingForConfirmationByVendor === true ?
                            <div className="m-modal">
                                {
                                    this.state.PendingConfirm === true ?
                                        <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Pending for Confirmation By Vendor</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset Name*</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Date & Time*</label>
                                                            <input type="text" className="form-control" disabled value="16 Sep 2021 14:24" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className='form-group'>
                                                            <label htmlFor='exampleInput'>Technisian name</label>
                                                            <div className="">
                                                                <Select className="form-control"
                                                                    showSearch
                                                                    placeholder="-- Please Select --"
                                                                    optionFilterProp="children"
                                                                    filterOption={(input, option) =>
                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                > <Option value="1">User1</Option>
                                                                    <Option value="2">User2</Option>
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="m-page__button top-space text-center">
                                                            <button type='button' className='btn muted-button  deca-btn-orange' onClick={this._doReject}>Reject</button>
                                                            <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={this._doAccept}>Accept</button>
                                                            <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={this._doReSchedule}>Re Schedule</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : false
                                }
                                {
                                    this.state.Accept === true ?
                                        <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Accept</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset Name*</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className='form-group'>
                                                            <label htmlFor='exampleInput'>Technisian name</label>
                                                            <div className="">
                                                                <Select className="form-control"
                                                                    showSearch
                                                                    placeholder="-- Please Select --"
                                                                    optionFilterProp="children"
                                                                    filterOption={(input, option) =>
                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                > <Option value="1">User1</Option>
                                                                    <Option value="2">User2</Option>
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="m-page__button top-space text-center">
                                                            <button type='button' className='btn muted-button  deca-btn-orange' onClick={this._doPendingConfirmBack}>Back</button>
                                                            <button type='button' onClick={this._doNavToWOReschedule} className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : false
                                }
                                {
                                    this.state.Reject === true ?
                                        <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Reject</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset Name*</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Remarks*</label>
                                                            <textarea type="text" rows="3" className="form-control"></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="m-page__button top-space text-center">
                                                            <button type='button' className='btn muted-button  deca-btn-orange' onClick={this._doPendingConfirmBack}>Back</button>
                                                            <button type='button' onClick={this._doNavToWOReschedule} className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : false
                                }
                                {
                                    this.state.Reschedule === true ?
                                        <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Reschedule</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset Name*</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Date & Time*</label>
                                                            <DatePicker className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Reason For ReSchedule*</label>
                                                            <textarea type="text" rows="3" className="form-control"></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="m-page__button top-space text-center">
                                                            <button type='button' className='btn muted-button  deca-btn-orange' onClick={this._doPendingConfirmBack}>Back</button>
                                                            <button type='button' onClick={this._doNavToWOReschedule} className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : false
                                }
                            </div>

                            : false
                    }
                    {
                        this.state.PendingForConfirmationByVendor === true ?
                            <div className="overlay" onClick={this._doCloseModal}>

                            </div>
                            : false
                    }
                    {
                        this.state.TechnisianCompleted === true ?
                            <div className="m-modal">
                               <div className="m-modal__container">
                                            <div className="m-modal__header">
                                                <h5 className="m-modal__title">Work Order Request</h5>
                                                <span className="m-modal__close" onClick={this._doCloseModal}>
                                                    <i className="fa fa-close"></i>
                                                </span>
                                            </div>
                                            <div className="m-modal__body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="">
                                                            <div className="c-pic__img">
                                                                <img src="https://powerengineering101.com/wp-content/uploads/2016/05/How-Do-Electrical-Transformers-Work.jpg" className="" alt="asset-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Asset</label>
                                                            <input type="text" className="form-control" disabled value="Transformer" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Submitted Date & Time</label>
                                                            <input type="text" className="form-control" disabled value="16 Sep 2021 13:38" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Name of Technician</label>
                                                            <input type="text" className="form-control" disabled value="Amit Pandey" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Signature by Technician</label>
                                                            <img src="https://static.cdn.wisestamp.com/wp-content/uploads/2020/08/Oprah-Winfrey-Signature-1.png" className="signature" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor='exampleInput'>Remarks*</label>
                                                            <textarea type="text" rows="3" className="form-control" disabled value="Lorem Ipsum is simply dummy text of the printing and"></textarea>
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                        </div>

                            </div>

                            : false
                    }
                    {
                        this.state.TechnisianCompleted === true ?
                            <div className="overlay" onClick={this._doCloseModal}>

                            </div>
                            : false
                    }
                </div>
            </div >
        )
    }
}
export default WorkOrder;



